import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../ui/form/BaseFormView";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import JobStatusForm from "../JobStatusForm";
import JobStatus from "../../../../model/job/JobStatus";
import JobStatusFormBody from "../JobStatusFormBody";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {JobStatus} data edited job status data.
	 */
	onSubmit: (data: JobStatus) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Job status to edit
	 */
	editedJobStatus: JobStatus;
}

type IState = BaseFormViewState<JobStatusForm>;

export default class EditJobStatusFormView extends BaseFormView<JobStatusForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: JobStatusForm.createFromJobStatus(this.props.editedJobStatus),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<JobStatusFormBody form={this.state.form}
								   onFieldChange={this.onFieldChanged}
								   onFieldCompleted={this.onFieldCompleted}
								   onFocusChange={this.onFocusChange}
								   onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update Status"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}
